import auth from "@/services/auth";
import store from "@/store/index";

export default async (to, from, next) => {
  const isGuest = to.matched.some(record => !!record.meta.guest);
  if (isGuest) {
    return await handleGuestRoute(next);
  }

  return await handleRoute(next, to);
};

async function handleGuestRoute(next) {
  if (await auth.isAuthenticated()) {
    return next({ name: "my-plane" });
  }

  next();
}

async function handleRoute(next, to) {
  const isProtected = to.matched.some(record => !!record.meta.requiresAuth);
  if (await auth.isAuthenticated()) {
    if (!hasCustomer()) {
      await store.dispatch("customers/getCustomer");
      store.dispatch("cart/getCart");
    }

    return next();
  }

  try {
    await auth.checkSession();
    if (!hasCustomer()) {
      await store.dispatch("customers/getCustomer");
      store.dispatch("cart/getCart");
    }

    return next();
  } catch (e) {
    if (isProtected) {
      next({ name: "login" });
      return;
    }

    return next();
  }
}

function getCustomer() {
  return store.getters["customers/customer"];
}

function hasCustomer() {
  return !!getCustomer();
}
